export default "__VITE_ASSET__Dy$5x6yj__"